import { useContext } from 'react';

import { MissionContext } from '../index';

/**
 * Returns the MissionContext if available, or null if not within a MissionContextProvider.
 * Use this hook when you need to optionally access mission data.
 */
export const useMissionContextOptional = () => useContext(MissionContext);
